import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/bhojanshala/packages";

export const Route = createFileRoute("/admin/_bhojanshala/bhojan-packages")({
  component: Page,
});
